import React, {  useState, useEffect } from 'react'
import 'video-react/dist/video-react.css';
import { useLocation } from "react-router-dom";
import moment from 'moment'
//import { useNavigate } from 'react-router-dom';

import DayPicker from 'react-day-picker';
import LOCALE from '../datepicker/DatePickerLocale'
import { useHistory } from 'react-router-dom'
import Trailer from './components/Trailer'
import ShowtimeProgram from './components/ShowtimeProgram';
import _ from 'lodash'
import ShowtimeListItems from './components/ShowtimeListItems'
import ShowtimeList from './components/ShowtimeList'
import { appHeightChanged } from '../../actions/app-actions'
import { useDispatch } from 'react-redux'

export default function EbilletMovieContainer({ allEvents, movie_id,
    allOrganizers, allEventsTypes, allMovieBases, iframeId, appHeightChanged , movie, allLocations}) {
  
    let history = useHistory()
    const location = useLocation();
    let showtimesPerFilm = findShowtimes(movie_id)
    const backTo = location?.state?.backTo
    

    let ageCensor= [{ id: 'alle', image: '/images/censur/censur-a.png' },
        { id: '7', image: "/images/censur/censur-7.png" },
        { id: '11', image: "/images/censur/censur-11.png" },
        { id: '15', image: '/images/censur/censur-15.png' }
    ]

   

    function findShowtimes(movie_id) {
      
        let arr = []
        allEvents.map((event) => {

            if (event._movieNo == movie_id) {
              
                arr.push(event)
            }

        })
        return arr
        
    }

    //function isBaseMovie(movieid) {
    //    let movie_arr = []
    //    showsToday.map((movie) => {
    //        if (movieid[0]._movieBaseNo > 0) {

    //            if (movie._movieBaseNo === movieid[0]._movieBaseNo) {
    //                movie_arr.push(movie)
    //            }
    //        }
    //        else if (movie._no === movieid[0]._no) {
    //            movie_arr.push(movieid[0])

    //        }
    //    })
    //    return movie_arr
    //}

 //   const dispatch = useDispatch()
    const [trailerPlaying,setTrailerPlaying] = useState(false)
    //const [showCalendar, setShowCalendar] = useState(false)
    //const [currentStartDate, setCurrentStartDate] = useState(moment())
    //const history  = useHistory();
    //const location = useLocation();
    //const iframeId = location.state.iframeId
    //const clickedMovie = location.state.clickedMovie
    //const allmoviebases = location.state.allMovieBases
    //const futureFilms = location.state.futureFilms ? location.state.futureFilms : ''
    //const allEvents = location.state.eventsWithFilter ? location.state.eventsWithFilter : location.state.allEvents
    //const selectedMovieId = location.state.movie_id
    //const movies = location.state.movieData
    //const [movie, setMovie] = useState(movies?.length > 1 ? chosenMovie() : movies && movies[0])
    //const already_selected_date = location.state.selectedDate
    //const already_selectednr = location.state.selected
    const [selectedDate, setSelectedDate] = useState( moment().format('DD-MM-YYYY'))
    //const allEventsTypes = location.state.allEventsTypes
    //const [calendarDate, setCalendarDate] = useState(  new Date());
    //const [selected, setSelected] = useState(already_selectednr ? already_selectednr : 1);
    //const selectedOrgs = location.state.organizers
  
  //  const orgsArr = location.state.allOrganizers

    let n = movie.censoring
    const mc = isEmpty(movie.censoring) === false ? _.find(ageCensor, (icon) => { return n.includes(icon.id) }) : null

    Object.assign(movie, { censorImage: isEmpty(movie.censoring) === false ? mc?.image : null })

    useEffect(() => {
        appHeightChanged(iframeId, true)
    })

    //function dipatchAppHeight() {

    //    dispatch(appHeightChanged(iframeId, true))
    //}


    function chosenMovie() {
        let movie 
        movies.map((mov) => {
            if (mov._no == selectedMovieId) {
                movie = mov              
            }
            return movie
        })
        return movie
   } 
   

    let eventsWithMovieArr = []
    allEvents && allEvents.sort((a, b) => a.dateTime > b.dateTime ? 1 : -1).map(ev => {
        
          
              if (ev._movieNo === movie._no &&  ev.webEnable._show === 1) {           
                eventsWithMovieArr.push(ev)
            }

        })

    function getUnique(arr, index) {
        
        const unique = arr
            .map(e => e[index])
        
            // store the keys of the unique objects
            .map((e, i, final) => final.indexOf(e) === i && i)
            // eliminate the dead keys & store unique objects
            .filter(e => arr[e]).map(e => arr[e]);

        return unique;
    }

   // console.log(eventsWithMovieArr)
    function makeShowtimeArr(org) {
        let showtimeNr = []
        eventsWithMovieArr.map(e => {
            if (org._organizerNo === e._organizerNo) {
                showtimeNr.push(e._no)
            }
        })
        return showtimeNr
    }

  
    function moviesShowtimes(org) {
        let showtimes = []
        eventsWithMovieArr.map(e => {
          // console.log(e, 'e')
            if (org._organizerNo === e._organizerNo) {
                let event = Object.assign( e )
               // console.log(event, 'event')
                if (event._eventTypeNo === 0) {
                    event.type = null
                }
                else event.type = allEventsTypes.filter(ev => { return ev._no === event._eventTypeNo })
                showtimes.push( e )          
            }

        })
        
        return showtimes
    }

   
    function findBioName(event) {
       // console.log(event, 'event')
        let bio     
        let dt = event.dateTime && moment(event.dateTime).format('DD-MM-YYYY')

        allOrganizers.map(org => {
            if (org._no === event._organizerNo) {              
                bio = org.name
            }
        })
        return bio
    }

   

   

    let date_Arr = []
   
    let movieAtBios = []   // ebillet
    for (let i = 0; i < eventsWithMovieArr.length; i++) {
        movieAtBios.push({
            bio_name: findBioName(eventsWithMovieArr[i]),
            org: eventsWithMovieArr[i]._organizerNo,
            validShowtimes: moviesShowtimes (eventsWithMovieArr[i]), 
            movieNo: eventsWithMovieArr[i]._movieNo,
            showtimeArr: makeShowtimeArr(eventsWithMovieArr[i]),
         
        })
        date_Arr.push(moment(eventsWithMovieArr[i].dateTime).format('DD-MM-YYYY'))
    }

 
    const movieAtCinemas = getUnique(movieAtBios, 'bio_name')
   
    function isEmpty(obj) {
        for (const prop in obj) {
            if (Object.hasOwn(obj, prop)) {
                return false;
            }
        }

        return true; 
    }

    const premiere = movie.openingDate ? <p className="premiere film-info-text" style={{ marginTop: '38px', marginBottom: '10px' }}><span style={{ color: '#949494' }}>Premiere: </span><label style={{ fontWeight:400 }}>{moment(movie.openingDate).locale('da').format('LL')}</label></p> : null;
    // console.log(movie)
    const scriptWriters = movie.scriptwriters && movie.scriptwriters.item.length > 0 && movie.scriptwriters.item[0] !== '' ?
        <p className='film-info-text'> <span style={{ color: '#949494', letterSpacing: '0.51px' }}>{movie.scriptwriters.item.length ? 'Manuskript' : ''}</span>
            <label style={{fontWeight:'normal'} }>{_.map(movie.scriptwriters, (scriptWriter) => scriptWriter).join(', ')}</label>
        </p> : null;

    const originalTitel = movie.length && <p className='film-info-text'>
        <span style={{ color: '#949494' }}>Orig. titel:</span>
        <label style={{ fontWeight: 'normal' }}> {movie.originalName}</label>
    </p>

    const actors = movie.actors && movie.actors.item.length > 0 && <p className='film-info-text'>
        <span style={{ color: '#949494' }}>Skuespillere:</span>
        <label style={{ fontWeight: 'normal' }}>{Array.isArray(movie.actors.item) === true ?  _.map(movie.actors.item, (actor) => actor).join(', ') : movie.actors.item}</label>
    </p>

    const description = movie.synopsis && isEmpty(movie.synopsis) === false ? <label key={movie.id} style={{ whiteSpace: 'pre-line', marginTop: '2px', fontFamily: "PP Neue Montreal", fontWeight: 400 }} className="description" dangerouslySetInnerHTML={{ __html: movie.synopsis.replace(/(?:\r\n|\r|\n)/g, '<br />') }} /> : null;

    const synopsis = movie.synopsis && isEmpty(movie.synopsis) === false && <p className='film-info-text' style={{ }}>
        <span style={{ color: '#949494' }}>Synopsis:</span>
        {description}    
         </p>
    
    const directors = movie.directors && movie.directors.item.length > 0 && <p className='film-info-text'>
        <span style={{ color: '#949494', letterSpacing:'0.51px' }}>Instruktør:</span>
        <label style={{ fontWeight: 'normal' }}> {Array.isArray(movie.directors.item) === true ? _.map(movie.directors.item, (actor) => actor).join(', ') : movie.directors.item}</label>
    </p>
   
    const genre = movie.genre && <p className='film-info-text'>
        <span style={{ color: '#949494', letterSpacing: '0.51px' }}>Genre:</span>
        <label style={{ fontWeight: 'normal' }}>{movie.genre} </label>
    </p>

    const length = movie.length && <p className='film-info-text'>
        <span style={{ color: '#949494', letterSpacing: '0.51px' }}>Længde:</span>
        <label style={{ fontWeight: 'normal' }}> {movie.length}</label>
    </p>

    const censur = movie.censoring && <p className='film-info-text'>
        <span style={{ color: '#949494', letterSpacing: '0.51px' }}>Aldersgrænse:</span>
        <label style={{ fontWeight: 'normal' }} > {movie.censoring}</label>
    </p>
  
    

    const handleVersion = (list) => {
       
        setMovie(list)
       
    }
  
    const trailerUrl = `https://admin.ebillet.dk/trailers/${movie.vimeoId}.mp4`
    
    const trailerPoster = `https://ebillet.dk/poster/advertisement/${movie.sliderNoText}`

    function navBack() {
        //  navigate(-1)
        let all_futurefilm_route = sessionStorage.getItem('back_to')
        all_futurefilm_route === '/alle-kommende-film' ? history.push(all_futurefilm_route): backTo ? history.push(backTo) : history.push('/ebillet')
       
    }

    function versionName(movie) {
        let name 
       
        
            allmoviebases.map((base) => {
                if (base._no === movie._movieBaseNo) {
                    let str = movie.name.replace(base.name, '')
                   
                    name = str ? str.replace('-','') : 'uden tekster'
                    return name
                }
              
                return name
            })
            return name
    }
    
    const lastShowtimeDay = date_Arr[date_Arr.length - 1];
 


    const nextShowtimeDate = moment(eventsWithMovieArr[0]?.dateTime).format('DD-MM-YYYY')  // the first showtime date for kommende films
   
   
    return (
        <>

            {allEvents.length ?
        <div className='film-details'>
            <main className='Movie' >
                {/*<p style={{ fontSize: '30px', fontWeight: 600, color: 'white', marginBottom: '50px' }}>{movie && movie.name}</p>*/}

                        {movie.vimeoId != null && movie.vimeoId !== '' &&
                    <div className='' style={{}}>
                    {trailerUrl ? <Trailer trailerUrl={trailerUrl} trailerPoster={trailerPoster} setTrailerPlaying={setTrailerPlaying} />
                        : null}


                </div>
                }
               
                <div className='info-container' style={{ marginTop: trailerPlaying === true ? '0px' : '0px' }}>
              
                    <div className='Poster'>
                        <img className='filmPoster' style={{ borderRadius:'16px' }} src={'https://poster.ebillet.dk/' + `${movie.largePath}`} />
                        <div className='age-banner poster-banner'>{isEmpty(movie.censoring) === false ? <img src={movie.censorImage} alt='age-banner' /> : null}</div>
                </div>
                    <div className='MovieInfo'>
                        <p className='film-title'>{movie && movie.name}</p>
                        {premiere}
                        <hr style={{  opacity:'0.1',margin:'30px 0px' }} />
                        {synopsis}
                      
                        <hr style={{ opacity: '0.1', margin: '30px 0px' }} />
                       
                        { isEmpty(movie.originalName) === false && originalTitel }
                        {scriptWriters }
                        {actors}
                        {directors}
                        {isEmpty(movie.genre) === false && genre}
                        {length}             
                        {isEmpty(movie.censoring) === false && censur}

                </div>
               
                </div>
              
            </main>
            <br />   <br />
            <section>
{/*                {movie._movieBaseNo > 0 && movies.length > 1 ? */}
              
{/*                    <div  style={{  margin: 'auto' }}>*/}
{/*                        <div className='versionContainer' >*/}
{/*                            <p style={{ color: 'white', margin: '16px', alignContent: 'center', fontSize: '36px', fontWeight: 500, letterSpacing: '0.38px',paddingLeft:'16px' }}> Vælg version:</p>*/}
{/*                            <div className='versioner' style={{marginLeft:movies.length === 2 ? '25%' : ''} } >*/}

{/*                                {lists.map((list, index) => (*/}

{/*                                    <div style={{*/}
{/*                                        alignItems: 'center', fontFamily: 'arial',*/}
{/*                                        boxShadow: '0px 5px 15px 0px rgba(0, 0, 0, 0.30)',*/}
{/*                                        height: '54px', borderRadius: '8px', backgroundColor:*/}
{/*                                            list._no === movie._no*/}
{/*                                                ? "#0E9D61"*/}
{/*                                                : "", border: list._no !== movie._no ? '1px solid rgba(247, 247, 247, 0.50) ' : '',marginRight:'16px'*/}
{/*} }>*/}
{/*                            <button*/}
                                
{/*                                key={list.id}*/}
{/*                                onClick={() => handleVersion(list)}*/}
{/*                                style={{height:'90%',*/}
{/*                                    width:  '259px' ,*/}
{/*                                     letterSpacing:'0.36px',*/}
{/*                                    fontWeight: 700 ,marginTop:'2px',*/}
{/*                                    color: 'white', fontSize: list._no === movie._no ? '19px' :'18px',*/}
{/*                                }}*/}
{/*                                        >  {versionName(list) }*/}
{/*                                            */}{/*{list.name.includes('- Med') && list.name.split('-')[2] ? list.name.split('-')[2] : list.name.includes('- Med') && list.name.split('-')[1] ? list.name.split('-')[1]: 'uden tekster' }                               */}
{/*                                            */}{/*{list.name.split('-')[1] ? list.name.split('-')[1] : 'uden tekster' }*/}
{/*                            </button>*/}
{/*                            </div>*/}
{/*                        ))}*/}

{/*                    </div>*/}
{/*                    </div>*/}
{/*                </div>*/}
{/*                    : ''}*/}
                <br />
              
               
               

            </section>
         
            <section className='orgs_container'>
              
                   
                    <ShowtimeList movieAtCinemas={movieAtCinemas} lastShowtimeDay={lastShowtimeDay}
                    already_selected_date={/*futureFilms === true ? nextShowtimeDate :*/selectedDate}
                />

              
            </section>

            <br></br>
            <br></br>
            <div className='back_btn_cont'>
                <div className='back_btn show-navigations'>
                    <span >             
                        <svg style={{marginTop:'1px',marginRight:'5px'}} xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                            <path d="M7.91663 3.11108L2.36107 8.66664L7.91663 14.2222" stroke="white" stroke-width="1.11111" stroke-linecap="round" />
                        </svg>
                  </span>
                    <button onClick={navBack} style={{ letterSpacing:'0.54px',fontSize: '18px', color: 'white', fontFamily: "PP Neue Montreal", fontWeight:600 } } >
                        Tilbage til oversigt</button>
                </div>
                </div>
            <br></br> <br></br>
                </div>
                : <div className="spinner"></div>
            }
        </>
    )
}